module.exports = __webpack_public_path__ + "img/smartHome-lg.fc6bad06.jpg";